import { BaseAuthFormModel } from '@/models';

export class FormModelLogin extends BaseAuthFormModel {
  getFields() {
    return {
      email: '',
      password: '',
    };
  }

  get authMethod(): 'login' {
    return 'login';
  }

  get sendArguments(): [string, string] {
    return ['email', 'password'];
  }
}
